"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readPoleForm = readPoleForm;
const __1 = require("..");
/**
 * Returns an IPoleForm for the given form if it is a Base Form or PLA Form, or null if it is neither.
 */
function readPoleForm(form) {
    if (__1.BaseForm.isBaseForm(form)) {
        return new __1.BaseForm(form);
    }
    if (__1.PLAForm.isPLAForm(form)) {
        return new __1.PLAForm(form);
    }
    return null;
}
//# sourceMappingURL=IPoleForm.js.map